import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchBookedCandidates,
  updateFilters,
  showFilterModal,
  setBookedCandidatesLoading,
  updatePagination,
  deSelectAllCandidate,
} from "@/reducers/client_candidates/candidatesbooked";
import { getIsFilterApplied } from "@/utilities/utils";

import TableSearch from "../../../dataTables/TableSearch";
import FilterButton from "../../../ListingFilters/FilterButton";
/**
 * SearchFilter component for filtering and searching candidates.
 *
 * @return {JSX.Element} The search filter component.
 */
export const SearchFilter = () => {
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesBooked,
  );
  const filterApplied = getIsFilterApplied(filters);
  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setBookedCandidatesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectAllCandidate());
      dispatch(fetchBookedCandidates(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};
